// Library
import React, { useState } from 'react';
// DatePicker from 'react-datetime-picker' without styles;
import DateTimePicker from 'react-datetime-picker';

// CSS Style for this module
import styles from './DateTimeField.module.scss';

type ValuePiece = Date | null;
type Value = ValuePiece | [ValuePiece, ValuePiece];

/**
 * Interface for DateTimeFieldProps props
 */
interface DateTimeFieldProps {
	/**
	 * Custom styles of the field
	 */
	customStyles?: string;
	/**
	 * Default value for edit mode
	 */
	defaultValue?: Date;
	/**
	 * Minimum restrictive date to pick
	 */
	minDate?: Date;
	/**
	 * Maximun restrictive date to pick
	 */
	maxDate?: Date;
	/**
	 * onChange function for keeping track field value
	 * debounce is built in
	 */

	handleChange?: (value: Date) => void;
	/**
	 * Msg to be displayed when the status is error
	 */
	errorMsg?: string;
	/**
	 * Boolean for determining whether this is a required field
	 */
	status?: 'valid' | 'error';
	/** Element identifier selector for test */
	testId?: string;
}

export function DateTimeField({
	customStyles,
	defaultValue,
	minDate,
	maxDate,
	errorMsg = 'Please fill up the field',
	status = 'valid',
	handleChange = () => {
		return;
	},
	testId,
}: DateTimeFieldProps) {
	const [dateTime, setDateTime] = useState(defaultValue);

	const onChangeValue = (value: Date) => {
		setDateTime(value);
		handleChange(value);
	};

	return (
		<div className={[styles.container, customStyles].join(' ')}>
			<DateTimePicker
				value={dateTime}
				onChange={(value: Value) => onChangeValue(value as Date)}
				calendarAriaLabel="Toggle calendar"
				locale="en-AU"
				dayPlaceholder="dd"
				monthPlaceholder="mm"
				yearPlaceholder="yyyy"
				minDate={minDate}
				maxDate={maxDate}
				clearIcon={null}
				isClockOpen={false}
				disableClock={true}
				format="dd/MM/y HH:mm"
				// minDetail="year"
				maxDetail="minute"
				hourPlaceholder="hh"
				minutePlaceholder="mm"
				className={[styles['datetimepicker'], styles[`datetimepicker-${status}`]].join(' ')}
				data-testid={testId}
			/>
			<p
				className={[styles['error-msg'], status !== 'error' && styles['error-msg-hide']].join(' ')}
			>
				{errorMsg}
			</p>
		</div>
	);
}
